import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data }, replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || e?.message || "Error desconocido";
        const code = e?.response?.status ? ` (HTTP ${e.response.status})` : "";
        window.history.replaceState(null, "", window.location.pathname);
        setError(`${detail}${code}`);
      }
    };
    if (sessionId) run();
    else navigate("/login", { replace: true });
  }, [navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
        <div className="w-full max-w-md bg-white rounded-3xl border border-neutral-200 shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-8 text-center">
          <h1 className="font-display font-extrabold text-xl">No pudimos iniciar tu sesión</h1>
          <p data-testid="auth-error-detail" className="text-sm text-neutral-600 mt-3 leading-relaxed break-words">{error}</p>
          <Button
            data-testid="auth-retry-btn"
            onClick={() => { window.location.href = "/login"; }}
            className="w-full mt-6 h-11 rounded-xl bg-[#0092CC] hover:bg-[#007bad] text-white"
          >
            Volver a intentar
          </Button>
          <p className="text-xs text-neutral-400 mt-4">Si el mensaje se repite, envíanos esta pantalla a hola@mctecheventos.com</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#00AEEF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-neutral-500">Iniciando sesión...</p>
      </div>
    </div>
  );
}
